import React from "react";
import AgencyRegistrationForm from "./AgencyRegistrationForm";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, Building2 } from "lucide-react";
import "../../GisincidentManagement/ViewIncident/ViewIncident.css";

const CreateAgency = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const edit = state?.edit;

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div className="incv-header-banner">
        <button type="button" className="incv-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="incv-header-icon">
          <Building2 size={14} color="#fff" />
        </span>
        <div>
          <div className="incv-header-title">{edit ? "Edit Agency Details" : t('createagency_management_formheader')}</div>
          <div className="incv-header-subtitle">{edit ? "Update partner agency details" : "Register a new partner agency"}</div>
        </div>
      </div>
      <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px", padding: "20px 16px" }}>
        <AgencyRegistrationForm />
      </div>
    </div>
  );
};

export default CreateAgency;
